import { useEffect, useRef, useState } from 'react';
import { FormIcon } from './FormIcon.jsx';

/**
 * Single "⋯" action menu.
 * @param {{ items: Array<{ label: string; icon?: string; onClick: () => void; danger?: boolean; disabled?: boolean } | null | false>; label?: string; vertical?: boolean; align?: 'left' | 'right' }} props
 */
export function FormMenu({ items, label = 'Actions', vertical = false, align = 'right' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const visible = items.filter(Boolean);

  return (
    <div className="fm-menu" ref={ref}>
      <button
        type="button"
        className={`fm-icon-btn fm-menu-trigger${open ? ' is-open' : ''}`}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        <FormIcon name={vertical ? 'moreVertical' : 'more'} size={18} />
      </button>
      {open ? (
        <div className={`fm-menu-list fm-menu-list--${align}`} role="menu">
          {visible.map((item) => (
            <button
              key={item.label}
              type="button"
              role="menuitem"
              className={item.danger ? 'is-danger' : undefined}
              disabled={item.disabled}
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
                item.onClick();
              }}
            >
              {item.icon ? <FormIcon name={item.icon} size={16} /> : null}
              {item.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
